export default __webpack_public_path__ + "static/media/trackS.7fe5f308.svg";